import React from "react";
import { createRoot } from "react-dom/client";
import { HelmetProvider } from "react-helmet-async";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";

// Clear head tags saved by the pre-render; <Seo /> re-creates them.
document.querySelectorAll("[data-prerender]").forEach((el) => el.remove());

// Render fresh (no hydration). The pre-rendered HTML is for crawlers and link previews.
createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <HelmetProvider>
      <App />
    </HelmetProvider>
  </React.StrictMode>
);

reportWebVitals();
